// extracted by mini-css-extract-plugin
module.exports = {"pageLoaderWrapper":"PageLoader_pageLoaderWrapper__yZc9k"};